import "./index.scss";

export const BlueIndicator = () => {
  return (
    <div className="blue-indicator-wrapper">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="9"
        height="9"
        viewBox="0 0 9 9"
        fill="none"
      >
        <path
          d="M8.11547 4.49919C8.11547 6.74024 6.29874 8.55697 4.05769 8.55697C1.81664 8.55697 -9.29066e-05 6.74024 -9.29066e-05 4.49919C-9.29066e-05 2.25814 1.81664 0.441406 4.05769 0.441406C6.29874 0.441406 8.11547 2.25814 8.11547 4.49919Z"
          fill="#3272BE"
        />
      </svg>
    </div>
  );
};
